import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { feedService } from '../services/feedService'

export const getAllFeeds = createAsyncThunk(
  'feed/getAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await feedService.getAll(params)
      return response
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

// Separate from getAllFeeds/state.data (the mixed Polls/Posts/Notifications feed) --
// the Photo Gallery paginates independently (3/page) so it needs its own slot,
// same reasoning as courseSlice.adminList / subjectSlice.adminList.
export const getPhotoFeeds = createAsyncThunk(
  'feed/getPhotos',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await feedService.getAll({ ...params, feedable_type: 'App\\Models\\Photo' })
      return response
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createPoll = createAsyncThunk(
  'feed/polls',
  async (data, { rejectWithValue }) => {
    try {
      const response = await feedService.createPoll(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createPost = createAsyncThunk(
  'feed/posts',
  async (data, { rejectWithValue }) => {
    try {
      const response = await feedService.createPost(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createNotification = createAsyncThunk(
  'feed/notifications',
  async (data, { rejectWithValue }) => {
    try {
      const response = await feedService.createNotification(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createPhotoGallery = createAsyncThunk(
  'feed/photos',
  async (data, { rejectWithValue }) => {
    try {
      const response = await feedService.createPhotoGallery(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const deleteFeed = createAsyncThunk(
  'feed/delete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await feedService.deleteOne(id)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)


const initialState = {
  data: { data: [], current_page: 1, per_page: 10, total: 0, last_page: 1 },
  photosData: { data: [], current_page: 1, per_page: 3, total: 0, last_page: 1 },
  photosLoading: false,
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'feeds',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllFeeds.pending]: (state) => {
      if (!state.data?.data?.length) {
        state.loading = true
      }
    },
    [getAllFeeds.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllFeeds.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getPhotoFeeds.pending]: (state) => {
      if (!state.photosData?.data?.length) {
        state.photosLoading = true
      }
    },
    [getPhotoFeeds.fulfilled]: (state, action) => {
      state.photosData = action.payload
      state.photosLoading = false
    },
    [getPhotoFeeds.rejected]: (state, action) => {
      state.photosLoading = false
    },

    [createPoll.pending]: (state) => {
      state.loading = true
    },
    [createPoll.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [createPoll.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
    [createPost.pending]: (state) => {
      state.loading = true
    },
    [createPost.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [createPost.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createNotification.pending]: (state) => {
      state.loading = true
    },
    [createNotification.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [createNotification.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createPhotoGallery.pending]: (state) => {
      state.loading = true
    },
    [createPhotoGallery.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [createPhotoGallery.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [deleteFeed.pending]: (state) => {
      state.loading = true
    },
    [deleteFeed.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [deleteFeed.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
